import React from 'react';
import * as styles from './index.module.scss';

const FilledBox: React.FunctionComponent = () => <div className={styles.box} />;

export default FilledBox;
